import React, { useMemo } from 'react';
import { Text } from '@fragments';
import { ArtPreview, normalizeDocument } from '../../../../features/ArtEditor';
import { formatLabelKey } from '../../../../enums/formats';
import memoStudio from '../../../../utils/memoStudio';
import './styles.scss';

// The art a run made, attached to its message like the script card: its thumbnail (the
// cover of a carousel, stacked) opens that version in the panel (read-only when older).
function ArtCard({ studio: s, revision, onOpen }) {
  const { t } = s;
  const document = useMemo(() => normalizeDocument(revision.document), [revision]);
  const version = t('revision', { number: revision.revision_number });
  const format = t(formatLabelKey(document.format));
  const many = document.pages.length > 1;
  const meta = [format, document.aspect_ratio, many && t('artPages', { count: document.pages.length }), version].filter(Boolean).join(' · ');
  return <div className="studio-art-card">
    <button type="button" className="studio-art-card__open" onClick={() => onOpen(revision.id)} aria-label={`${t('openArt')}: ${version}`}>
      <span className={`studio-art-card__thumb ${many ? 'is-stack' : ''}`}><ArtPreview document={document} pageId={document.pages[0].id} rounded={false} /></span>
      <span className="studio-art-card__text">
        <Text.span weight={500} contrast={9}>{s.current?.title || format}</Text.span>
        <Text.caption contrast={6}>{meta}</Text.caption>
      </span>
    </button>
  </div>;
}

export default memoStudio(ArtCard, ['t', 'current']);
